import { Controller } from '@tencent/workbench';
import { MENU_CONFIGS } from './config';

@Controller({
    menuItems: MENU_CONFIGS,
})
export class TextStyleController {
    constructor() {
    }
}
